import { MessageReferenceContext } from '../Contexts';
import React from "react";
export function MessageReferenceProvider({ children }) {
    return (
        <MessageReferenceContext.Provider value={[]}>
            {children}
        </MessageReferenceContext.Provider>
    );
}
